import React, { useCallback, useMemo } from 'react';
import FormInput from 'components/Input/FormInput';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';

interface IProps {
	changePinCode: (value: string) => void;
}

const PinCodeField: React.FC<IProps> = ({ changePinCode }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('enterPinCode') },
			{
				validator(_, value) {
					if (!value || value.length === 6) {
						return Promise.resolve();
					}
					return Promise.reject(new Error(t('theValueMustContainNumberOfCharacters', { value: '6' })));
				},
			},
		],
		[t],
	);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const onlyDigits = e.target.value.replace(/\D/g, '');
			changePinCode(onlyDigits);
			return onlyDigits;
		},
		[changePinCode],
	);

	return (
		<FormInput
			testId="PinCodeField"
			name="pinCode"
			label="pinCodeLabel"
			maxLength={6}
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(PinCodeField);
